<template>
  <div>
    <!-- BOTON PARA MOVILES -->
    <div class="d-flex d-sm-none justify-center">
      <v-btn class="orange darken-1 mx-1 my-auto" width="100%"
        dark small text
        @click="mostrarDialogo = true"
        >Eliminar: {{ cortarString(producto.NOMBRE,tamañoLetra) }}</v-btn
      >
    </div>
    <!-- BOTON PARA LAPTOP / ESCRITORIO -->
    <v-btn
      class="red lighten-3 mx-auto my-auto d-none d-sm-flex"
      small
      text
      width="100%"
      @click="mostrarDialogo = true"
    >
      <!-- <v-icon>mdi-close</v-icon> -->
      Eliminar {{ cortarString(producto.NOMBRE,tamañoLetra) }}
    </v-btn>

    <v-dialog v-model="mostrarDialogo" max-width="600px">
      <v-card>
        <v-card-title class="noBreak">
          ¿Eliminar Producto del proyecto?
        </v-card-title>
        <v-card-text class="my-1 font-weight-bold text-subtitle-1 text--primary">
           Producto: 
        </v-card-text>
        <v-card-text class="my-1  text-subtitle-1 text--primary">
           {{ producto.NOMBRE }}.
        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <v-btn @click="mostrarDialogo=false" class="grey darken-1" dark>Cancelar</v-btn>
          <v-btn @click="eliminarProducto" class="red" dark>Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cortarStrings } from '../../../store/metodos'
export default {
  props:['producto'],
  data() {
    return {
      mostrarDialogo:false,
      tamañoLetra:50,
    };
  },

  computed: {
    
  },

  methods: {
    cortarString(string, tamaño){
      return cortarStrings(string,tamaño)
    },
    eliminarProducto() {
      this.$emit("eliminarProducto");
    },
    totalLetrasCortar()  {
      let w = window.innerWidth;
      // let tamaño = 0;
      if ( w < 600 ) this.tamañoLetra= 25;
      else if ( w < 980 && w > 600 ) this.tamañoLetra= 50;
      else if ( w < 1280 && w > 980 ) this.tamañoLetra= 100;
      else this.tamañoLetra = 120;
    },
  },

  created() {
    window.addEventListener('resize',this.totalLetrasCortar);
  },
};
</script>

<style></style>
